import { createInjectionKey } from "../../_utils/index.mjs";
export const treeInjectionKey = createInjectionKey('n-tree');